import { render, staticRenderFns } from "./root-layout.vue?vue&type=template&id=08d434ef"
import script from "./root-layout.vue?vue&type=script&lang=js"
export * from "./root-layout.vue?vue&type=script&lang=js"
import style0 from "./root-layout.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/root-layout.vue
// module id = zQD5
// module chunks = 0